"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SectionsListSchema = void 0;
const mongoose_1 = require("mongoose");
const offer_1 = require("./offer");
exports.SectionsListSchema = new mongoose_1.Schema({
    id: {
        type: Number,
        unique: true,
        required: true
    },
    name: {
        type: String,
        required: true
    },
    content: [Object],
    offerwallType: {
        type: String,
        enum: offer_1.OfferwallTypes,
        default: 'BASE'
    }
});
